import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import "./iwarehouses_style.css";
import "@github/relative-time-element";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import DeletedWarehouses from "./DeletedWarehouses";

function Warehouses({ handleMenuClick }) {
  const [warehouses, setWarehouses] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [showDeleted, setShowDeleted] = useState(false); // Nuevo estado para controlar la vista

  const filteredData = searchValue
    ? warehouses.filter((data) =>
        data.name.toUpperCase().includes(searchValue.toUpperCase())
      )
    : warehouses;

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;

  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const showEntries = (e) => {
    setDataPerPage(e.target.value);
  };

  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };

  //Obtener datos de los almacenes
  const getWarehouses = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/warehouses`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.status === 200) {
        setWarehouses(res.data.data);
        setLoading(false);
      } else {
        Swal.fire("Error", "Hubo un error al obtener los datos", "error");
        setLoading(false);
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
      setLoading(false);
    }
  };

  //Eliminar almacen
  const deleteWarehouse = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sí, eliminarlo",
        denyButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        const response = await axios.get(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/warehouses/deletedIWarehouses/${id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        console.log("Response:", response);

        Swal.fire("¡Eliminado!", "El elemento ha sido eliminado.", "success");
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  //Editar condicion de pago
  const updateWarehouse = async (id) => {
    try {
      //Obtener los datos de la condición de pago
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/warehouses/${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      const WarehouseData = response.data.data;

      const result = await Swal.fire({
        title: "Editar almacén",
        html:
          `<div class="form-grid">` +
          `<input type="text" id="name" class="swal2-input" placeholder="Nombre" value="${WarehouseData[0].name}">` +
          `<input type="text" id="code" class="swal2-input" placeholder="Acrónimo" value="${WarehouseData[0].code}">` +
          `<input type="number" id="number" class="swal2-input" inputmode="numeric" placeholder="N° de almacén" value="${WarehouseData[0].number}">` +
          `<input type="text" id="email" class="swal2-input" placeholder="Correo" value="${WarehouseData[0].email}">` +
          `</div>`,
        showDenyButton: true,
        confirmButtonText: "Actualizar",
        denyButtonText: "Cancelar",
        padding: "1px",
        color: "#000",
        backdrop: `
                    rgba(0,0,0,0.8)
                `,
        customClass: {
          confirmButton: "btn-amc-blue",
          denyButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },
        preConfirm: function () {
          const name = document.getElementById("name").value;
          const code = document.getElementById("code").value;
          const number = document.getElementById("number").value;
          const email = document.getElementById("email").value;

          if (!name || !code || !number || !email) {
            Swal.showValidationMessage("Todos los campos son obligatorios");
            return false;
          }

          return {
            name,
            code,
            number,
            email,
          };
        },
      });

      if (result.isConfirmed) {
        const updateUserData = result.value;
        // Realizar la solicitud para actualizar el warehouse
        const updateResponse = await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/warehouses/updateIWarehouses/${id}`,
          updateUserData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );
        Swal.fire(
          "¡Actualizado!",
          "El almacén ha sido actualizado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelado",
          "No se ha realizado ninguna actualización.",
          "error"
        );
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const markError = (input) => {
    input.classList.add("input-error");
  };

  const clearErrorOnInput = (input) => {
    input.addEventListener("input", () => {
      if (input.value.trim()) {
        input.classList.remove("input-error");
      }
    });
  };

  //Crear nuevo almacen
  const createWarehouse = async () => {
    try {
      const result = await Swal.fire({
        title: "Crear almacén",
        html:
          '<div class="form-grid">' +
          '<input type="text" id="name" class="swal2-input" placeholder="Nombre">' +
          '<input type="text" id="code" class="swal2-input" placeholder="Acrónimo">' +
          '<input type="number" id="number" class="swal2-input" inputmode="numeric" placeholder="N° de almacén">' +
          '<input type="text" id="email" class="swal2-input" placeholder="Correo">' +
          "</div>",
        showDenyButton: true,
        confirmButtonText: "Crear",
        denyButtonText: "Cancelar",
        padding: "1px",
        color: "#000",
        backdrop: `
                    rgba(0,0,0,0.8)
                `,
        customClass: {
          confirmButton: "btn-amc-blue",
          denyButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },

        didOpen: () => {
          const inputs = [
            document.getElementById("name"),
            document.getElementById("code"),
            document.getElementById("number"),
            document.getElementById("email"),
          ];

          inputs.forEach(clearErrorOnInput);
        },

        preConfirm: () => {
          //   const name = document.getElementById("name").value;
          //   const code = document.getElementById("code").value;
          //   const number = document.getElementById("number").value;
          //   const email = document.getElementById("email").value;
          const name = document.getElementById("name");
          const code = document.getElementById("code");
          const number = document.getElementById("number");
          const email = document.getElementById("email");

          let isValid = true;

          [name, code, number, email].forEach((input) => {
            if (!input.value.trim()) {
                markError(input);
                isValid = false;
            }
          });

          if (!isValid) {
            Swal.showValidationMessage("Todos los campos son obligatorios");
            return false;
          }

          return {
            name: name.value,
            code: code.value,
            number: number.value,
            email: email.value,
          };

        //   if (!name || !code || !number || !email) {
        //     Swal.showValidationMessage("Todos los campos son obligatorios");
        //     return false;
        //   }

        //   return {
        //     name,
        //     code,
        //     number,
        //     email,
        //   };
        },
      });

      if (result.isConfirmed) {
        const userData = result.value;

        const response = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/warehouses/createIWarehouses`,
          userData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        Swal.fire(
          "¡Creado!",
          "El elemento ha sido creado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Acción cancelada.", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  useEffect(() => {
    getWarehouses();
  }, [updateTrigger]);

  return (
    <>
      <Helmet>
        <title>Horus | Almacenes</title>
      </Helmet>
      <ScrollToTop />
      <div className="table-responsive">
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer"
          id="datatables_wrapper"
        >
          <div className="text-right mb-2">
            <button
              className="btnn"
              onClick={() => setShowDeleted(!showDeleted)}
            >
              {showDeleted ? "Ver Activos" : "Ver Eliminados"}
            </button>
          </div>
          {showDeleted ? (
            <DeletedWarehouses
              setUpdateTrigger={setUpdateTrigger}
              updateTrigger={updateTrigger}
            />
          ) : (
            <>
              <div className="text-right mb-4">
                <button className="btnn" onClick={createWarehouse}>
                  Añadir Almacenes
                </button>
              </div>
              <div className="row justify-content-between mb-2">
                <div className="col-sm-12 col-md-4">
                  <div
                    className="dataTables_length mb-2"
                    id="dataTables_length"
                  >
                    <label className="d-flex justify-content-start">
                      <span className="mr-2 p-2">Mostrar</span>
                      <select
                        name="datatables_length"
                        aria-controls="datatables_length"
                        className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                        onChange={showEntries}
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="ml-2 p-2">registros</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4">
                  <div className="datatables_filter" id="datatables_filter">
                    <label className="d-flex justify-content-end">
                      <input
                        type="search"
                        id="searchInput"
                        className="form-control form-control-sm"
                        placeholder="Buscar..."
                        aria-controls="datatables"
                      />
                      <button className="btnn" onClick={handleSearch}>
                        Buscar
                      </button>
                    </label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <table
                    className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                    role="grid"
                    aria-describedby="datatables_info"
                  >
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Acrónimo</th>
                        <th>N° de almacén</th>
                        <th>Correo</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.map((warehouse) => (
                        <tr key={warehouse.id} data-master-id={warehouse.id}>
                          <td>{warehouse.name}</td>
                          <td>{warehouse.code}</td>
                          <td>{warehouse.number}</td>
                          <td>{warehouse.email}</td>
                          <td>
                            <FaEdit
                              className="editButton"
                              onClick={() => {
                                updateWarehouse(warehouse.id);
                              }}
                            />
                            <FaTimes
                              className="deleteButton"
                              onClick={() => {
                                deleteWarehouse(warehouse.id);
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <nav aria-label="Page navigation example">
                  <ul className="pagination">
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        Anterior
                      </button>
                    </li>
                    {pageNumbers.map((pageNumber) => (
                      <li className="page-item" key={pageNumber}>
                        <button
                          className="page-link"
                          onClick={() => paginate(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      </li>
                    ))}
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === pageNumbers.length}
                      >
                        Siguiente
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Warehouses;
